import React from "react";
import { styled } from "@mui/styles";

const StyledOnBoardingHeader = styled('div')(({ theme }) => ({
    borderBottom: '1px solid #d5d5d5',
    textTransform: 'uppercase',
    paddingBottom: '20px',
    textAlign: 'center',
    fontSize: '22px',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    userSelect: 'none',
}));

const OnBoardingHeader = ({ children }) => {
    return (
        <StyledOnBoardingHeader>
            {children}
        </StyledOnBoardingHeader>
    )
}

export default OnBoardingHeader;
